<script>
    import {Listeners} from "../../../constants/listeners";
    import AdaptersTour from "../../../component/adapters/Tour.vue";

    export default {
        data () {
            return {
                steps: [
                    {
                        target: '#tour-step-0',
                        content: this.$t('lang.cluster.tour.0c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-1',
                        content: this.$t('lang.cluster.tour.1c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-2',
                        content: this.$t('lang.cluster.tour.2c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-3',
                        content: this.$t('lang.cluster.tour.3c'),
                        placement: 'bottom',

                    },
                    {
                        target: '#tour-step-4',
                        content: this.$t('lang.cluster.tour.4c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-5',
                        content: this.$t('lang.cluster.tour.5c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-6',
                        content: this.$t('lang.cluster.tour.6c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-7',
                        content: this.$t('lang.cluster.tour.7c'),
                        placement: 'bottom',
                    },
                    {
                        target: '#tour-step-7-1',
                        content: this.$t('lang.cluster.tour.7_1c'),
                    },
                    {
                        target: '#tour-step-8',
                        content: this.$t('lang.cluster.tour.8c'),
                        placement: 'right',
                    },
                    {
                        target: '#tour-step-9',
                        content: this.$t('lang.cluster.tour.9c'),
                    },
                    {
                        target: '#tour-step-10',
                        content: this.$t('lang.cluster.tour.10c'),
                    },
                    {
                        target: '#tour-step-11',
                        content: this.$t('lang.cluster.tour.11c'),
                    },
                    {
                        target: '#tour-step-12',
                        content: this.$t('lang.cluster.tour.12c'),
                        onNext: () => {
                            return new Promise(async (resolve) => {
                                this.$emitter.emit(Listeners.CLUSTER_TOUR_SET_NODE);
                                resolve();
                            });
                        }
                    },
                    {
                        target: '#tour-step-13',
                        content: this.$t('lang.cluster.tour.13c'),
                        placement: 'right',
                    },

                ],
            }
        },
        computed: {
            getTourStartListenerId() {
                return Listeners.CLUSTER_TOUR_START;
            },
        },
        methods: {
            onTourStart() {
                this.$emitter.emit(Listeners.CLUSTER_TOUR_SET_NODE);
            },
        },
        components: {
            AdaptersTour,
        },
    }
</script>

<template>
    <AdaptersTour :steps="steps" :listener-id-start="getTourStartListenerId" />
</template>
